import TradingView from './TradingView';

export default TradingView;
